// extracted by mini-css-extract-plugin
module.exports = {"icon__position":"Dropdown_icon__position__3_hE0","input":"Dropdown_input__3FNiN"};